
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// @components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// @composable
import useNotifications from '@/common/composable/useNotifications'

// @new-services
import timeSlotsAPI from '@/new-services/time-slots.service'

// @types
import { TimeSlotStatus } from '@/new-services/types/time-slots'

// @validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        Modal,
        TheSelect
    },
    props: {
        timeSlotId: {
            type: [Number, null] as PropType<number | null>,
            required: true
        },
        statusId: {
            type: [Number, null] as PropType<number | null>,
            required: true
        }
    },
    emits: ['cancel', 'saved'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            statusId: props.statusId as number | null
        })

        const data_state = reactive({
            statuses: {
                is_loading: false,
                is_failed: false,
                list: [] as TimeSlotStatus[]
            }
        })

        const state_form$ = useVuelidate({
            statusId: { required }
        }, state)

        const loadStatuses = async () => {
            try {
                data_state.statuses.is_loading = true

                const response = await timeSlotsAPI.getTimeSlotStatuses({ page: 1, limit: 9999, typeId: 4 })
                data_state.statuses.list = response.data.data

                data_state.statuses.is_failed = false
            } catch (error) {
                console.error(error)
                data_state.statuses.is_failed = true
            } finally {
                data_state.statuses.is_loading = false
            }
        }

        onBeforeMount(loadStatuses)

        const emitCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const onSubmit = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return
            
            try {
                state.is_loading = true

                await timeSlotsAPI.updateTimeSlotStatus(props.timeSlotId as number, state.statusId as number)

                notifications.notify({ type: 'success', title: 'Статус сохранен' })
                emit('saved')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При смене статуса произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            data_state,
            emitCancel,
            onSubmit,
            loadStatuses,
        }
    }
})
